import React from 'react';

import { Tab } from './Tab';

interface Props {
  tabSelect: string;
  onTabChange: (customer: string) => void;
}

export const Tabs = (props: Props) => {
  return (
    <div style={{ flexDirection: 'row', display: 'flex' }}>
      <Tab
        tabSelect={props.tabSelect}
        onTabChange={props.onTabChange}
        customer={'HUK'}
      />
      <Tab
        tabSelect={props.tabSelect}
        onTabChange={props.onTabChange}
        customer={'HEK'}
      />
    </div>
  );
};
